import { QLookup } from '@qualio/ui-components';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Group } from '../types';

const filterGroupOption = (group: Group, searchTerm: string | undefined) =>
  !searchTerm || group.name.toLowerCase().includes(searchTerm.toLowerCase());

/**
 * @description Returns the data view and search filter shared by the QLookup group pickers
 */
export const useGroupLookupView = () => {
  const { t } = useTranslation();

  const groupDataView = useMemo(
    (): QLookup.DataView<Group> => ({
      name: {
        header: t('groups.table.groupName'),
        width: 'auto',
        render: (value) => <span style={{ textTransform: 'uppercase' }}>{String(value)}</span>,
      },
    }),
    [t],
  );

  return { groupDataView, filterOption: filterGroupOption };
};
